import "./dropdowns.css";
import Profile from "./Profile";
import {
  getNotificaitons,
  markAllNotificaitonsRead,
} from "../../api/modules/b2droppie.class";
import { routes } from "../../routes";
import { useSelector } from "react-redux";
import { CheckCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import {ReactComponent as Bell} from "../../assets/icons/bell.svg"

const HeaderDropdowns = ({ isLogged, loading, setLoading }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [notifiData, setNotifiData] = useState([]);
  const [markingAll, setMarkingAll] = useState(false);
  const [showEllipsis, setShowEllipsis] = useState(false);
  const [showNotificationDropdown, setShowNotificationDropdown] =
    useState(false);
  const notificationDropdownRef = useRef(null);
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const verification = useSelector((state) => state.verification);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (showTooltip) {
      const timer = setTimeout(() => {
        setShowTooltip(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showTooltip]);

  useEffect(() => {
    fetchNotifications(1, true);
  }, []);

  useEffect(() => {
    function handleOutsideClick() {
      setShowEllipsis(false);
    }
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  useEffect(() => {
    function handleNotificationDropdownOutside(event) {
      if (
        notificationDropdownRef.current &&
        !notificationDropdownRef.current.contains(event.target)
      ) {
        setShowNotificationDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleNotificationDropdownOutside);
    return () => {
      document.removeEventListener(
        "mousedown",
        handleNotificationDropdownOutside
      );
    };
  }, []);

  const fetchNotifications = async (pageNum = 1, replace = false) => {
    if (!isLoggedIn) return;
    try {
      setLoading(true);
      const response = await getNotificaitons(pageNum);
      const resData = response?.data?.data;

      if (resData?.data) {
        const allNotifications = resData.data;
        setNotifiData((prev) =>
          replace ? allNotifications : [...prev, ...allNotifications]
        );
        setHasMore(!!resData.next_page_url);
        setPage(resData.current_page);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = () => {
    if (hasMore && !loading) {
      fetchNotifications(page + 1);
    }
  };

  const handleMarkAllRead = async () => {
    setLoading(true);
    try {
      setMarkingAll(true);
      const response = await markAllNotificaitonsRead();
      if (response?.data?.success) {
        await fetchNotifications(1, true);
      }
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    } finally {
      setLoading(false);
      setMarkingAll(false);
    }
  };

  useEffect(() => {
    if (verification && verification.message) {
      const newNotification = {
        id: verification.id,
        read_at: null,
        data: verification,
      };

      setNotifiData((prev) => {
        const exists = prev.some((item) => item.id === verification.id);
        if (exists) return prev;
        return [newNotification, ...prev];
      });
    }
  }, [verification]);
  const hasUnread = notifiData.some((item) => item.read_at === null);
  return (
    <div className="mobile-dropdown d-center">
      {/* <AllLanguages setLoading={setLoading} /> */}
      {isLogged && (
        <>
          {notifiData.length > 0 ? (
            <div
              ref={notificationDropdownRef}
              className="custom-notification-dropdown-container"
            >
              <div className="notification-dropdown-wrapper">
                <button
                  style={{ boxShadow: "none" }}
                  className={`custom-toggle notification-toggle ${
                    isDarkMode ? "custom-toggle-dark" : "custom-toggle-light"
                  }`}
                  onClick={() =>
                    setShowNotificationDropdown(!showNotificationDropdown)
                  }
                >
                  <Bell size={16} className="bell-icon fast-ring" />
                  {hasUnread && <span className="notification-badge"></span>}
                </button>

                {showNotificationDropdown && (
                  <div className="dropdown-notification-menu">
                    <div className="d-space-between notification-header">
                      <div className="d-start">
                        <Bell
                          size={19}
                          stroke="none"
                          fill="currentColor"
                          className="header-notification-icon"
                        />
                        <span className="header-title ms-1">Notification</span>
                      </div>
                      <div
                        className="custom-ellipsis-dropdown"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowEllipsis((prev) => !prev);
                        }}
                      >
                        <button className="ellipsis-btn">
                          <i className="fa fa-ellipsis-v text-lavender-gray"></i>
                        </button>

                        {showEllipsis && (
                          <div
                            className="ellipsis-menu-box ellipsis-enter"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div
                              className="ellipsis-menu-item"
                              onClick={() => {
                                setShowEllipsis(false);
                                handleMarkAllRead();
                              }}
                            >
                              <CheckCheck size={14} className="me-2" />
                              {markingAll ? "Marking..." : "Mark All as Read"}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="notification-scroll">
                      {notifiData.length > 0 ? (
                        <>
                          {notifiData.map((item) => {
                            const info = item.data;
                            return (
                              <div
                                key={item.id}
                                className="beautiful-notification-item"
                                onClick={() => {
                                  setShowNotificationDropdown(false);
                                  if (info?.battle_id) {
                                    const encodedBattleId = btoa(
                                      info.battle_id
                                    );
                                    window.location.href = `/battle/play/${encodedBattleId}`;
                                  } else {
                                    navigate(routes.NOTIFICATIONS, {
                                      state: { notification: item },
                                    });
                                  }
                                }}
                              >
                                <div className="d-center notification-icon">
                                  <Bell className="icon-white" size={18} />
                                </div>
                                <div className="notification-content">
                                  <div className={` ${isDarkMode ? "notification-status" : "notification-status notification-status-light"}`}>
                                    {info?.status
                                      ? info.status.replace(/_/g, " ")
                                      : info?.battle_id
                                      ? "Battle"
                                      : "Notification"}
                                  </div>
                                  <div className="notification-message">
                                    {info.message.length > 50
                                      ? info.message.slice(0, 50) + "..."
                                      : info.message}
                                  </div>
                                  {info.verification_code && (
                                    <div className="notification-code">
                                      Code:{" "}
                                      <strong>{info.verification_code}</strong>
                                    </div>
                                  )}
                                </div>
                                {info.read_at && (
                                  <div className="unread-dot"></div>
                                )}
                              </div>
                            );
                          })}

                          {hasMore && (
                            <div
                              className="load-more-container"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <button
                                className="load-more-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleLoadMore();
                                }}
                                disabled={loading}
                              >
                                {loading ? (
                                  <>
                                    <div className="spinner"></div>
                                    <span>Loading...</span>
                                  </>
                                ) : (
                                  <span>Load More Notifications</span>
                                )}
                              </button>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="empty-notifications">
                          <Bell size={44} className="empty-icon" />
                          <p className="empty-title">No new notifications</p>
                          <p className="empty-subtitle">
                            You're all caught up!
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <button
              className="icon-button notifi-empt"
              onClick={() => setShowTooltip(!showTooltip)}
            >
              <Bell size={16} />

              {showTooltip && (
                <span className="notif-tooltip">No notifications</span>
              )}
            </button>
          )}
          <div className="show-profile-icon"> <Profile isDarkMode={isDarkMode} />
          </div>
        </>
      )}
    </div>
  );
};

export default HeaderDropdowns;
